import React, { Fragment } from 'react';
import { ButtonGroup } from '@tencent/spaui';
import { settingMap, roleTarget } from './config.jsx';
import { getEmployeeNames, getGroupNames } from './helper';
import { RPCFactory } from '../../../../utils/RequestUtil';

import Picker from '../../../common/picker';

import StrategyRadio from './radio';
import useEdit from './useEdit';

const Page = (props) => {
  const currentType = settingMap[1].key;

  const [isEdit, setEdit] = React.useState(false);
  // const isXundaAccount = window.pageProps.xundaOuterCode !== 0;
  const {
    strategyHooks,
    strategy,
    setStrategy,
    selectedDistributor,
    // setSelectedDistributor: setSelectedEmployeeDistributor,
    setSelectedEmployeeDistributor,
    setSelectedGroupDistributor,
    totalListOfDistributor,
    targetName,
    targetKey,
    targetSearchFields,
    strategyMap,
    target,
    setTarget,
    ruleSource,
    setRuleSource,
  } = useEdit(props);
  const [showError, setShowError] = React.useState(false);

  React.useEffect(() => {
    RPCFactory.leadsSetting.getBasicRule().done((data) => {
      if (!data.leadsDistriStrategy || data.leadsDistriStrategy == '') {
        setStrategy('RULE_TOTAL_AVG');
      } else {
        setStrategy(data.leadsDistriStrategy);
      }
      if (data.leadsDistriTarget == 'USER') {
        setSelectedEmployeeDistributor(data.leadsDistriEmployees);
      } else {
        setSelectedGroupDistributor(data.leadsDistriGroups);
      }
      setTarget(data.leadsDistriTarget);
      setRuleSource(data.source);
    });
  }, []);

  const save = (isApply) => {
    if (!selectedDistributor || selectedDistributor.length == 0) {
      setShowError(true);
      return;
    }
    RPCFactory.leadsSetting
      .updateBasicRule({
        leadsDistriTarget: target,
        leadsDistriStrategy: strategy,
        ...(target === 'USER'
          ? { leadsDistriEmployees: selectedDistributor }
          : { leadsDistriGroups: selectedDistributor }),
        source: ruleSource,
      })
      .done(() => {
        if (isApply) {
          props.apply(currentType);
        } else {
          props.feedbackHooks.showSuccessTip('保存成功');
        }
        setEdit(false);
      })
      .fail((code, msg) => {
        props.feedbackHooks.showErrorTip(`保存失败，错误信息：${msg}`);
      });
  };

  const renderScope = () => (
    <ButtonGroup
      className="scope-switch"
      data={Object.keys(roleTarget).map((key) => ({
        value: key,
        label: roleTarget[key],
      }))}
      disabled={!isEdit || ruleSource !== 0}
      value={target}
      onChange={(event, value, buttonProps) => {
        setTarget(value);
        console.log(value);
      }}
    />
  );

  const renderEditPicker = () => (
    <div id="customUserPicker">
      <Picker
        valueKey={targetKey}
        targetName={targetName}
        searchPlaceholder={`搜索${targetName}名称`}
        searchFields={targetSearchFields}
        data={totalListOfDistributor}
        value={selectedDistributor}
        disabled={ruleSource !== 0}
        onChange={(e, value) => {
          setShowError(false);
          if (target === 'USER') {
            setSelectedEmployeeDistributor(value);
          } else {
            setSelectedGroupDistributor(value);
          }
        }}
      />
      {showError ? <div className="error-text">{`请选择分配${targetName}`}</div> : null}
    </div>
  );

  const renderDistributeNames = () => (
    <li>
      <p className="tt">{`分配${targetName}`}</p>
      <div className="desc">
        <p className="desc-tt">{target ==='USER' ? getEmployeeNames(props.employeeList, selectedDistributor).join(',') : getGroupNames(props.groupList, selectedDistributor).join(',')}</p>
      </div>
    </li>
  );
  const renderContent = () => (
    <div className="sec baserule-sec save">
      <div className="card">
        <div className="panel base-set">
          <div className="tt-wraper fe-flex-spacebetween">
            <em className="tt">
              <strong>基础规则分配</strong>
            </em>
            <div className="action-wraper">
              <a
                className="edit"
                onClick={() => {
                  setEdit(true);
                }}
              >
                编辑
              </a>
              {
                props.type !== settingMap[1].key ? (
                  <a
                    className="edit"
                    onClick={() => props.apply(currentType)}
                  >
                    应用规则
                  </a>
                ) : (
                  <a
                    className="edit"
                    onClick={() => props.cancelApply(currentType)}
                  >
                    取消应用
                  </a>
                )}
            </div>
          </div>
          {renderScope()}
          <div className="rules">
            <ul className="baserule-infolist">
              {strategyMap.map((ele, index) =>
                ele.key == strategy ? (
                  <li>
                    <p className="tt">分配方式</p>
                    <div className="desc">
                      <p className="desc-tt">{ele.title}</p>
                      <p className="desc-sub">{ele.desc}</p>
                    </div>
                  </li>
                ) : null,
              )}
              {renderDistributeNames()}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );

  const renderEdit = () => (
    <div className="sec baserule-sec">
      <div className="card">
        <div className="panel base-set">
          <em className="tt">
            <strong>基础规则分配</strong>
          </em>
          {renderScope()}
          <div className="rules">
            <div className="spa-ui-group with-vertical spaui-component">
              <StrategyRadio {...strategyHooks} strategyMap={strategyMap} />
            </div>
          </div>
        </div>
        <div className="panel base-set">
          <em className="tt">
            <strong>{`分配${targetName}`}</strong>
          </em>
          <div className="rules">
            {renderEditPicker()}
            <div className="action-wraper">
              <button
                className="spaui-button spaui-button-default"
                type="button"
                onClick={() => {
                  save(false);
                }}
              >
                保存
              </button>
              <button
                className="spaui-button spaui-button-primary"
                type="button"
                onClick={() => {
                  save(true);
                }}
              >
                应用规则
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return <Fragment>{isEdit ? renderEdit() : renderContent()}</Fragment>;
};

export default Page;
